import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import StorySection from "./components/StorySection";
import Features from "./components/Features";
import Collections from "./components/Collections";
import Bestsellers from "./components/Bestsellers";
import Journal from "./components/Journal";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ShopAll from "./components/ShopAll";
import ProductDetail from "./components/ProductDetail";
import Collectionspage from './components/Collectionspage';
import { FaWhatsapp } from "react-icons/fa";
import Login from './components/Login';
import CheckoutPage from "./components/CheckoutPage";
import CartPage from "./components/CartPage";
import RegisterPage from './components/RegisterPage';
import ContactPage from './components/ContactPage';
import ForgotPassword from "./components/ForgotPassword";
import Dashboard from "./components/Dashboard";
import TermsAndConditions from './components/TermsAndConditions';
import TakeANote from './components/TakeANote';
import Signature from './components/Signature';
import FindYourState from './components/FindYourState';
import WishlistPage from './components/WishlistPage';
import Profile from "./components/Profile";
import ReturnExchange from "./components/ReturnExchange";
import ShippingPolicy from "./components/ShippingPolicy";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Compare from './components/Compare';
import Blogs from './components/Blogs';
import BlogDetails from './components/BlogDetails';
import AboutUs from './components/AboutUs';
import Orders from './components/Orders';
import OrderDetails from './components/OrderDetails';
import PaymentSuccessful from './components/PaymentSuccessful';
import PaymentFailed from './components/PaymentFailed';
function Home(){
return(
<>
  <Header />
  <Hero />
  <StorySection />
  <Features />
  <Collections />
  <Bestsellers />
  {/* <Journal /> */}
  <Footer />
</>
)
}

function App() {
return (
<BrowserRouter basename="/">
   <ScrollToTop />
<Routes>
    <Route path="/" element={<Home />} />
    <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
    <Route path="/takeanote" element={<TakeANote/>} />
    <Route path="/shop-all" element={<ShopAll />} />
    <Route path="/Dashboard" element={<Dashboard />} />
    <Route path="/product/:slug" element={<ProductDetail />} />
    <Route path="/collection" element={<Collectionspage />} />
    <Route path="/login" element={<Login/>} />
    <Route path="/cart" element={<CartPage/>} />
    <Route path="/checkout" element={<CheckoutPage/>} />
    <Route path="/register" element={<RegisterPage/>} />
    <Route path='/contact' element={<ContactPage/>}/>
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path='/signature' element={<Signature/>}/>
    <Route path='/FindYourState' element={<FindYourState/>}/>
     <Route path='/wishlist' element={<WishlistPage/>}/>
     <Route path="/profile" element={<Profile />} />
     <Route path="/compare" element={<Compare />} />
     <Route path="/privacy-policy" element={<PrivacyPolicy />} />
     <Route path="/shipping-policy" element={<ShippingPolicy />} />
     <Route path="/return-exchange-policy" element={<ReturnExchange />} />
     <Route path="/blogs" element={<Blogs />} />
     <Route path="/blogs/:slug" element={<BlogDetails />} />
     <Route path="/about" element={<AboutUs />} />
     <Route path="/payment-successful" element={<PaymentSuccessful />} />
     <Route path="/payment-failed" element={<PaymentFailed/>} />
     <Route 
 path="/orders" 
 element={<Orders />} 
/>
<Route 
 path="/order-details/:id" 
 element={<OrderDetails/>}
/>
</Routes>

{/* <a
  href="https://wa.me/your-number"
  target="_blank"
  rel="noreferrer"
  className="whatsapp-float"
>
  <FaWhatsapp />
</a> */}
</BrowserRouter>
);
}

export default App;